// departments.entity.ts

import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity("departments")
export class Department {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column("varchar", { name: "department_name", length: 255 })
    departmentName: string;

    @Column("varchar", { name: "department_code", length: 50, nullable: true })
    departmentCode: string;

    @Column("int", { name: "created_by", nullable: true })
    createdBy: number;

    @CreateDateColumn({ name: "created_at", type: "datetime" })
    createdAt: Date;

    @Column("int", { name: "updated_by", nullable: true })
    updatedBy: number;

    @UpdateDateColumn({ name: "updated_at", type: "datetime" })
    updatedAt: Date;
}